// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Tq-z","imageAndVideoCount":"Uq-z","imageAndVideoContainer":"Vq-z","viewAllReviews":"Wq-z"};